import {useState} from "react";
import {Button, Card, Flex, Form, message, Typography, Upload} from "antd";
import Apiurl from "../ConstURL";
import {InboxOutlined, CloudUploadOutlined} from '@ant-design/icons';
import axios from "axios";

const {Title} = Typography;

export default function Addtask() {
    const [form] = Form.useForm();
    const [fileList, setFileList] = useState([]);
    const [loading, setLoading] = useState(false);

    const beforeUpload = (file) => {
        const isTXT = file.type === 'text/plain';
        if (!isTXT) {
            message.error(`${file.name} это не txt`);
        }
        return isTXT || Upload.LIST_IGNORE;
    };

    const normFile = (e) => {
        if (Array.isArray(e)) {
            return [...e.fileList];
        }
        let newFileList = [...e.fileList];
        if (e.fileList.length > 0) {
            newFileList[0]["status"] = "done";
        }
        return newFileList;
    };

    const onChangeupload = (info) => {
        setFileList([...info.fileList]);
    };

    const Sendrequest = (values) => {
        setLoading(true);
        const data = new FormData();
        data.append('taskfile', values.dragger[0].originFileObj);
        const config = {
            "headers": {
                "content-type": 'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s'
            }
        };
        axios.post(Apiurl + "/task/create?token=" + localStorage.getItem("token"), data, config)
            .then((res) => {
                if (res.data.Created) {
                    message.success("Задача добавлена! ID: " + res.data.Taskid, 9);
                    form.resetFields();
                    setFileList([]);
                } else {
                    message.error("Задача не добавлена! Ошибка", 9);
                }
            })
            .catch((err) => {
                message.error("Ошибка при отправке: " + err.message);
            })
            .finally(() => setLoading(false));
    };

    return (
        <div>
            <Title level={3} style={{marginBottom: 24}}>Добавить задачу</Title>

            <Card style={{maxWidth: 520}}>
                <Form
                    layout="vertical"
                    name="addtask"
                    form={form}
                    onFinish={Sendrequest}
                    autoComplete="off"
                >
                    <Form.Item label="Файл TXT">
                        <Form.Item
                            rules={[{required: true, message: "Загрузите txt файл!"}]}
                            name="dragger"
                            valuePropName="fileList"
                            getValueFromEvent={normFile}
                            noStyle
                        >
                            <Upload.Dragger
                                maxCount={1}
                                name="files"
                                fileList={fileList}
                                onChange={onChangeupload}
                                beforeUpload={beforeUpload}
                                multiple={false}
                                customRequest={(info) => setFileList([info.file])}
                                className="upload-dragger"
                            >
                                <p style={{fontSize: 40, color: '#a017ff', marginBottom: 8}}>
                                    <CloudUploadOutlined/>
                                </p>
                                <p className="ant-upload-text">
                                    Нажмите или перетащите файл
                                </p>
                                <p className="ant-upload-hint">
                                    Поддерживается только формат .txt
                                </p>
                            </Upload.Dragger>
                        </Form.Item>
                    </Form.Item>

                    <Form.Item style={{marginBottom: 0}}>
                        <Button
                            type="primary"
                            htmlType="submit"
                            size="large"
                            loading={loading}
                            icon={<InboxOutlined/>}
                        >
                            Добавить задачу
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
}
